<app-table
  [dataSource]="dataSource"
  [columnMap]="columnMap"
  [showActionColumn]="true"
  [showMenuButton]="true"
  [showCheckbox]="true"
  [firstColumnClickable]="true"
  [isRowActive]="isRowActiveFn"
  [showRunButton]="false"
  [showDownloadResultButton]="false"
  [showDeleteMenuButton]="false"
  [showGetInfoButton]="false"
  [subMenuItems]="subMenuItems"
  (checkboxChanged)="checkboxChanged.emit($event)"
  (firstColumnClicked)="getInfoClicked.emit($event.data)"
  (rowMenuOpened)="onRowMenuOpenedInternal($event)"
  (rowMenuClosed)="rowMenuClosed.emit()"
>
  <ng-container *appTableCell="'status'; row: rowTypeToken; let row = row">
    <ng-container>
      <button
        mat-flat-button
        [ngClass]="getStatusClass(row)"
        [style.--progress-percent]="(getEffectiveProgress(row) || 0) + '%'"
      >
        {{ getEffectiveStatus(row) | titleCase }}
      </button>
    </ng-container>
  </ng-container>
</app-table>

<mat-menu #downloadMenu="matMenu">
  <ng-container *ngIf="getActiveRowStatus() === 'error'; else normalDownloadOptions">
    <button
      i18n
      *ngIf="userCanManage"
      mat-menu-item
      (click)="downloadRequested.emit({ type: 'logs', analysisId: activeRowId! })"
    >
      Logs
    </button>
  </ng-container>
  <ng-template #normalDownloadOptions>
    <button i18n mat-menu-item (click)="downloadRequested.emit({ type: 'results', analysisId: activeRowId! })">
      Results
    </button>
    <button
      i18n
      *ngIf="userCanManage"
      mat-menu-item
      (click)="downloadRequested.emit({ type: 'logs', analysisId: activeRowId! })"
    >
      Logs
    </button>
    <button
      i18n
      *ngIf="userCanManage"
      mat-menu-item
      (click)="downloadRequested.emit({ type: 'raw', analysisId: activeRowId! })"
    >
      Raw Data
    </button>
  </ng-template>
</mat-menu>

<mat-menu #pluginsMenu="matMenu">
  <ng-container [ngSwitch]="getPluginsMenuState()?.status">
    <button mat-menu-item disabled *ngSwitchCase="LoadingState.Error">Failed to fetch plugins.</button>
    <ng-container *ngSwitchCase="LoadingState.Ready">
      <button i18n mat-menu-item disabled *ngIf="getPluginsMenuState()?.items?.length === 0">
        No plugins available.
      </button>
      <button
        mat-menu-item
        *ngFor="let plugin of getPluginsMenuState()?.items"
        (click)="pluginLaunched.emit({ pluginId: plugin.pluginId, analysisId: activeRowId! })"
      >
        {{ plugin.name }}
      </button>
    </ng-container>
  </ng-container>
</mat-menu>
